import { ChartData, ChartDatum } from './types';

type BottomAxisValuesProps = {
  chartData: ChartData[];
  granularity?: number;
};

export const formatBottomAxisValues = ({
  chartData,
  granularity = 3,
}: BottomAxisValuesProps) =>
  chartData[0].data
    .filter((_item: ChartDatum, index: number) => index % granularity === 0)
    .map((item: ChartDatum) => item.x);
